const Schema = () => ({
  fieldsets: [{ id: 'default', title: 'Default', fields: [] }],
  properties: {},
  required: [],
  title: 'Quote',
});

export default Schema;
